import type { SVGProps } from 'react';

interface IconProps extends SVGProps<SVGSVGElement> {
  size?: number | string;
}

export function HomeIcon({ size = 24, className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...props}
    >
      <path
        d="M20.8256 9.923L13.3256 2.423C12.974 2.07149 12.4972 1.87402 12 1.87402C11.5028 1.87402 11.026 2.07149 10.6744 2.423L3.17438 9.923C2.99957 10.0967 2.86098 10.3035 2.76668 10.5312C2.67237 10.7589 2.62422 11.0031 2.62501 11.2496V20.2496C2.62501 20.5479 2.74354 20.8341 2.95451 21.0451C3.16549 21.256 3.45164 21.3746 3.75001 21.3746H9.75001C10.0484 21.3746 10.3345 21.256 10.5455 21.0451C10.7565 20.8341 10.875 20.5479 10.875 20.2496V15.3746H13.125V20.2496C13.125 20.5479 13.2435 20.8341 13.4545 21.0451C13.6655 21.256 13.9516 21.3746 14.25 21.3746H20.25C20.5484 21.3746 20.8345 21.256 21.0455 21.0451C21.2565 20.8341 21.375 20.5479 21.375 20.2496V11.2496C21.3758 11.0031 21.3276 10.7589 21.2333 10.5312C21.139 10.3035 21.0005 10.0967 20.8256 9.923ZM19.125 19.1246H15.375V14.2496C15.375 13.9512 15.2565 13.665 15.0455 13.4541C14.8345 13.2431 14.5484 13.1246 14.25 13.1246H9.75001C9.45164 13.1246 9.16549 13.2431 8.95451 13.4541C8.74354 13.665 8.62501 13.9512 8.62501 14.2496V19.1246H4.87501V11.4042L12 4.27925L19.125 11.4042V19.1246Z"
        fill="currentColor"
      />
    </svg>
  );
}
